import styled from 'styled-components';

const LoadingIndicatorWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const SpinnerWrapper = styled.div`
  height: 142px;
  position: relative;
  width: 142px;
`;

const SpinnerLoadingCircle = styled.div`
  animation: rotate 1s infinite linear;
  aspect-ratio: 1;
  background:
    radial-gradient(farthest-side, var(--primary-oqio-blue) 100%, #0000) top/25px 25px no-repeat,
    conic-gradient(#0000 25%, var(--primary-oqio-blue)),
    var(--greyscale-dark-white);
  border-radius: 50%;
  mask: radial-gradient(farthest-side, #0000 calc(100% - 25px), #000 0);
  width: 100%;

  @keyframes rotate {
    100% {
      transform: rotate(1turn);
    }
  }
`;

const SpinnerSuccessCircle = styled.div`
  align-items: center;
  border: 25px solid var(--primary-oqio-blue);
  border-radius: 50%;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

const LoadingIndicatorMessage = styled.div`
  font-size: var(--font-size-regular);
  margin-top: 20px;
  text-align: center;
`;

const LoadingSuccessContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const LoadingIndicatorLayout = {
  LoadingIndicatorWrapper,
  SpinnerWrapper,
  SpinnerLoadingCircle,
  SpinnerSuccessCircle,
  LoadingIndicatorMessage,
  LoadingSuccessContentWrapper
};
